import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { PurchasedItems } from '../PurchasedItems/PurchasedItems';

/**
 * Collapsible products list (the gray items box). The PromoCode field and the
 * price breakdown (subtotal/tax/total) are rendered OUTSIDE this wrapper, in
 * Details.tsx, in the order items → promo → subtotal/tax → total (ACDEV-25187:
 * the coupon must sit above the totals, not below them).
 *
 * Per-template spacing is encoded in `template.styles.detailsBodyStack`
 * (see TemplateStyleConfigurations) — no `template.type` branching here.
 */
export const DetailsWrapper = () => {
  const { template } = useContext(CheckoutContext);

  return (
    <div className={template.styles.detailsBodyStack}>
      <PurchasedItems />
    </div>
  );
};
